(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('ListaDiDistribuzione', ListaDiDistribuzione);

        ListaDiDistribuzione.$inject = ['$resource'];

    function ListaDiDistribuzione ($resource) {
        var resourceUrl =  'api/liste-di-distribuzione';

        var resource = $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                url: resourceUrl
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:idListaDiDistribuzione'
            },
            'queryPaged': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/paged'
            },
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                url: resourceUrl + '/:id'
            },
            'delete': {method: 'DELETE', url: resourceUrl + '/:id'},
            'query': {
                method: 'GET',
                isArray: true,
                url: resourceUrl
            }
        });

        return resource;
    }
})();